import {Injectable} from "@angular/core";
import {Actions, createEffect, ofType} from "@ngrx/effects";
import * as EcommerceTaxClassesAction from '../actions/ecommerce-tax-classes.action';
import {DbResponse} from "../../shared/interceptors/db-response";
import {filter, map, mergeMap} from 'rxjs/operators';
import {LoadEcommerceTaxClasses} from "../actions";
import {EcommerceService} from "../../websites/website/ecommerce/ecommerce.service";
import {IDsDropdownOption} from "../../shared/components/ds-dropdown/ds-dropdown-option";
import {TextUtils} from "../../shared/utils/text-utils";

@Injectable()
export class EcommerceTaxClassesEffect {

  loadEcommerceTaxClasses = createEffect(() => this._actions$.pipe(
    ofType(EcommerceTaxClassesAction.LOAD_ECOMMERCE_TAX_CLASSES),
    mergeMap((action: LoadEcommerceTaxClasses) => {
      const {websiteId} = action.payload;
      let taxClassesList: IDsDropdownOption[] = [];
      let taxClassesListFilter: IDsDropdownOption[] = [];

      return this._ecommerceService.getEcommerceTaxClasses(websiteId)
        .pipe(
          filter((response: DbResponse) => !!response),
          map((response: DbResponse) => {
              if (response.success && response?.data?.dataKey) {
              const data = response?.data?.dataKey;
              data.forEach(item => {
                taxClassesList.push({ value: item?.slug, label: item?.name });
                taxClassesListFilter.push({ value: item?.slug, label: TextUtils.getText('text_addTagBtn') + ' ' + item?.name });
              });
              return new EcommerceTaxClassesAction.LoadEcommerceTaxClassesSuccess({
                data: taxClassesList,
                filterData: taxClassesListFilter,
                websiteId: websiteId,
                loaded: true
              });
            }
            return new EcommerceTaxClassesAction.LoadEcommerceTaxClassesFail({websiteId});
          })
        );
    })
  ));


  constructor(
    private _actions$: Actions,
    private _ecommerceService: EcommerceService,
  ) {
  }

}
